import { useMemo } from 'react';

import { useClient } from 'urql';
import { fromPromise } from 'xstate';

import { type FetchPaymentInfoResponse } from '../../setup/sweetpass-checkout.machine.types';
import {
  SweetpassPaymentInfoDocument,
  type SweetpassPaymentInfoQuery,
  type SweetpassPaymentInfoQueryVariables,
} from './graphql/SweetpassPaymentInfo.generated';

// ─────────────────────────────────────────────────────────────────────────────

export const useFetchPaymentInfoActor = () => {
  const client = useClient();

  const fetchPaymentInfo = useMemo(
    () =>
      fromPromise<FetchPaymentInfoResponse>(async () => {
        const response = await client
          .query<SweetpassPaymentInfoQuery, SweetpassPaymentInfoQueryVariables>(
            SweetpassPaymentInfoDocument,
            {},
            { requestPolicy: 'network-only' },
          )
          .toPromise();

        const paymentInfo = response.data?.customerPaymentInfo;

        if (!paymentInfo?.id || !paymentInfo.paymentEphemeralKey || !paymentInfo.paymentSessionId) {
          throw response.error ?? new Error(INVALID_RESULT_MESSAGE);
        }

        return {
          stripeCustomerId: paymentInfo.id,
          stripeCustomerKey: paymentInfo.paymentEphemeralKey,
          stripeSession: paymentInfo.paymentSessionId,
        };
      }),
    [client],
  );

  return { fetchPaymentInfo };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const INVALID_RESULT_MESSAGE = 'Invalid customerPaymentInfo result';
